import { PagesState, isPopupPanelID, tabFocusSelf } from './pages';
import * as Action from '../actions/ViewAction';

export const reducePagesByViewAction = (
  state: PagesState,
  action: Readonly<Action.ViewAction>,
): PagesState => {
  if (action.type === Action.VIEW_POINTER_DOWN) {
    const { tabs, popups, activeTab } = state;
    const tab = tabs[activeTab];
    const panelID = action.activePanel;

    if (isPopupPanelID(panelID)) {
      if (tab.focus === panelID || popups[panelID].parent === null) {
        return state;
      }
      return {
        ...state,
        tabs: [
          ...tabs.slice(0, activeTab),
          { ...tab, focus: panelID },
          ...tabs.slice(activeTab + 1),
        ],
      };
    }

    if (tab.focus === tabFocusSelf) {
      return state;
    }
    return {
      ...state,
      tabs: [
        ...tabs.slice(0, activeTab),
        { ...tab, focus: tabFocusSelf },
        ...tabs.slice(activeTab + 1),
      ],
    };
  }

  return state;
};
